/**
 * @constructor
 * @param {string} type
 * @param {string} name
 * @param {number} duration
 * @param {number=} delay
 * @returns {AnimFade}
 */
export function AnimFade(type, name, duration, delay) {
	this._name = name;
	this._duration = duration;
	this._delay = delay;
	this._type = type;

	/** {Phaser.Tween} */
	this._tween;
};

/**
 * @returns {Promise}
 */
AnimFade.prototype.run = function() {
	var _self = this;

	return new Promise(function(res) {
		_self._tween = madnes_tween_to(_self._name, { 'alpha': _self._type === "out" ? 0 : 1 }, {
			'duration': _self._duration,
			'delay': _self._delay,
			'callback': res
		});
	});
};

AnimFade.prototype.stop = function() {
	this._tween && this._tween.stop();
};